import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { cloneDeep } from 'lodash';
import { ITEM_SELECTOR_CARDS_CONFIG } from './ai-active-item-selector.config';
import { ButtonSize, CardOneListCardClickOutput, HeadingType, IconType, NgZorroIconTheme } from '@rappider/rappider-components/utils';
import { CardListConfig, EntityConfigInterface, RappiderCardsModule } from '@rappider/rappider-components';

@Component({
  selector: 'rappider-ai-active-item-selector',
  standalone: true,
  imports: [
    RappiderCardsModule
  ],
  templateUrl: './ai-active-item-selector.component.html',
  styleUrls: ['./ai-active-item-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RappiderAiActiveItemSelectorComponent implements OnInit, OnChanges {

  @Input() activeEntityConfig: EntityConfigInterface | undefined;
  @Input() entityData: any = {};
  @Input() entityDataListSelector = '';
  @Input() entityDataActiveItemSelector = '';
  @Input() cardListConfig: CardListConfig | undefined;

  @Output() itemSelected = new EventEmitter<string>();

  entityItems: any[] = [];


  itemSelectorCardsConfig = cloneDeep(ITEM_SELECTOR_CARDS_CONFIG);
  selectedEntityId: string | undefined;


  ngOnInit() {
    this.initData();
  }

  ngOnChanges() {
    this.initData();
  }

  initData() {
    this.mapModelsToCardConfig();
    this.entityItems = cloneDeep(this.entityData[this.entityDataListSelector]) || [];
  }

  onCardDetailClicked(cardData: CardOneListCardClickOutput) {
    console.log('Card detail clicked:', cardData);
    this.selectedEntityId = cardData?.data?.id || cardData?.item.data?.id;
    this.activeEntityConfig = cardData?.data?.data || cardData?.item?.data || cardData?.data || cardData?.item || cardData;
    this.itemSelected.emit(this.selectedEntityId);
  }

  onCardSelected(cardData: CardOneListCardClickOutput) {
    console.log('Card selected:', cardData);
    this.selectedEntityId = cardData?.data?.id || cardData?.item.data?.id;
    this.activeEntityConfig = cardData?.data?.data || cardData?.item?.data || cardData?.data || cardData?.item || cardData;
    this.itemSelected.emit(this.selectedEntityId);
  }

  mapModelsToCardConfig() {
    if (this.entityData && this.entityDataListSelector && this.entityData[this.entityDataListSelector]?.length) {
      this.itemSelectorCardsConfig.cardsConfig.items = this.entityData[this.entityDataListSelector].map((entityItem: any) => ({
        data: entityItem,
        type: 'layout',
        titles: [
          {
            type: HeadingType.H6,
            content: this.cardListConfig?.titleFieldName ? entityItem[this.cardListConfig?.titleFieldName] :
              entityItem['title'] || entityItem['name'] || entityItem?.id,
          }
        ],
        descriptions: [
          {
            typography: {
              fontSize: 'var(--subtext-font-size)'
            },
            content: entityItem['description'] ?? ''
          }
        ],
        isTooltipEnabledOnDescription: true,
        image: null,
        imageTags: [{}],
        imageButtons: [],
        imageButtons2: [{
          name: 'preview-layout',
          icon: {
            name: 'eye',
            type: IconType.NgZorro,
            theme: NgZorroIconTheme.Outline
          },
          customColorSettings: {
            backgroundColor: 'var(--section-background-color)',
            color: 'var(--text-color)'
          },
          shadowSettings: {
            boxShadow: '0 0 0 var(--section-background-color)'
          },
          borderSettings: {
            borderColor: 'transparent'
          },
          size: ButtonSize.Small,
          tooltipText: 'Preview'
        },
        {
          icon: {
            name: 'check',
            type: IconType.NgZorro,
            theme: NgZorroIconTheme.Outline
          },
          name: 'set-active-layout',
          customColorSettings: {
            backgroundColor: 'var(--section-background-color)',
            color: 'var(--text-color)'
          },
          shadowSettings: {
            boxShadow: '0 0 0 var(--section-background-color)'
          },
          borderSettings: {
            borderColor: 'transparent'
          },
          size: ButtonSize.Small,
          tooltipText: 'Set as Active Layout'
        }],
      })) as any;
    }
  }

}
